import { defineStore } from 'pinia'

export const useFilterStore = defineStore('filter', {
  state: () => {
    return {
      activeFilters: undefined,
      filters: undefined,
      items: undefined,
    }
  },
  getters: {
    getActiveFilters (state) {
      return state.activeFilters
    },
    getFilters (state) {
      return state.filters
    },
    async hasMultipleFilters (state) {
      return state.filters.length > 1
    }
  },
  actions: {
    getItems(type) {
      const filteredItems = this.filterItems(type)
      return filteredItems
    },
    filterItems(type) {
      if (!this.activeFilters) {
        return this.items[type]
      }
      const items = []
      this.items[type].forEach((item) => {
        for (const [key, value] of Object.entries(this.activeFilters)) {
          if (key == 'startDate') {
            if (item[key] >= value[0] && item[key] <= value[1]) {
              items.push(item)
            }
          } else {
            if (this.filterString(key, value, item)) {
               items.push(item)
            }
          }
        }
      })
      return items
    },
    filterString(key, value, item) {
      if (!item[key]) return false
      if (Array.isArray(item[key])) {
        return item[key].includes(value)
      } else if (item[key] === value) {
        return true
      }
      return false
    },
    async setItems(items, type) {
      const parsedItems = JSON.parse(items)

      this.items = {
        ...this.items,
        [type]: Object.values(parsedItems)
      }
    },
    setActiveFilters(id, target) {
      if (id == null || id === 'all') {
        this.activeFilters = undefined
        return
      }
      this.activeFilters = {
        [target]: id
      }
    },
    checkActiveFiltersEmpty() {
      if (Object.keys(this.activeFilters).length === 0) {
        this.activeFilters = undefined
      }
    },
    async setFilters(filters) {
      const parsedFilters = JSON.parse(filters)

      // make filters Object an Array
      this.filters = Object.values(parsedFilters)
    },
  }
})
